import React from 'react';

function TransactionDetails({ transactions, clientId, produitsData }) {
  function formatDate(datetime) {
    const date = new Date(datetime);
    const day = date.getDate().toString().padStart(2, '0');
    const monthNames = [
      'Janvier',
      'Février',
      'Mars',
      'Avril',
      'Mai',
      'Juin',
      'Juillet',
      'Août',
      'Septembre',
      'Octobre',
      'Novembre',
      'Décembre',
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month}, ${year}`;
  }

  console.log(transactions.transactions);

  return (
    <div style={{ padding: '15px' }}>
      <h3>Transactions du client</h3>
      {transactions &&
      transactions.transactions &&
      transactions.transactions.filter(
        (transaction) =>
          transaction.client_details &&
          transaction.client_details.id === parseFloat(clientId)
      ).length > 0 ? (
        <table className="table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Produits</th>
              <th>Quantité</th>
              <th>Prix unitaire (FCFA)</th>
              <th>Type</th>
              <th>Montant Total (FCFA)</th>
            </tr>
          </thead>
          <tbody>
            {transactions.transactions
              .filter(
                (transaction) =>
                  transaction.client_details &&
                  transaction.client_details.id === parseFloat(clientId)
              )
              .map((filteredTransaction) => (
                <tr key={filteredTransaction.id}>
                  <td>{formatDate(filteredTransaction.created_at)}</td>
                  <td className="align-middle">
                    <ul className="list-unstyled mb-0">
                      {filteredTransaction.produits_associes.map((produit) => (
                        <li key={produit.produit}>
                          {produitsData?.data.find(
                            (p) => p.id === produit.produit
                          )?.nom || 'Nom inconnu'}
                        </li>
                      ))}
                    </ul>
                  </td>
                  <td className="align-middle">
                    <ul className="list-unstyled mb-0">
                      {filteredTransaction.produits_associes.map((produit) => (
                        <li key={produit.produit}>{produit.quantite}</li>
                      ))}
                    </ul>
                  </td>
                  <td className="align-middle">
                    <ul className="list-unstyled mb-0">
                      {filteredTransaction.produits_associes.map((produit) => (
                        <li key={produit.produit}>{produit.prix} Fcfa</li>
                      ))}
                    </ul>
                  </td>
                  <td className="fw-bold" style={{ color: '#009688' }}>
                    {filteredTransaction.type}
                  </td>
                  <td>{filteredTransaction.montant_total} Fcfa</td>
                </tr>
              ))}
          </tbody>
        </table>
      ) : (
        <div>Pas de transaction effectuée.</div>
      )}
    </div>
  );
}

export default TransactionDetails;
